import styles from "./styles.mobile.module.scss";
import { LocalSearchBar } from "../../CustomComponents/LocalSearchBar";
import { GlobalSearchBar } from "../../CustomComponents/GlobalSearchBar";
import { ReactNode } from "react";
import classNames from "classnames";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "../../../hooks/redux";
import { useVitalsAIMode } from "../../../hooks/useVitalsAIMode";
import { isHomeHealthExternalUser } from "../../../constants/sso";

export interface IProps {
  leftIcon: ReactNode;
  rightIcon: ReactNode;
  onClickSearch: () => void;
  title?: string;
  /** When true, hides the search bar and shows leftIcon inline with inlineTitle */
  hideSearch?: boolean;
  /** Title rendered inline with leftIcon when hideSearch is true */
  inlineTitle?: string;
}

export const Header: FC<IProps> = ({
  onClickSearch,
  leftIcon,
  rightIcon,
  title,
  hideSearch,
  inlineTitle,
}) => {
  const location = useLocation();

  const { user } = useAppSelector((state) => ({
    user: state.auth.user,
  }));

  const isHomeHealthExternal = isHomeHealthExternalUser(
    user?.groups,
    user?.email
  );

  // Define pages that should use local search
  const localSearchPages = [
    "/clinical",
    "/watchlist",
    "/bedexits",
    "/my-facility",
    "/motion-and-exits",
  ];

  const isLocalSearchPage = localSearchPages.includes(location.pathname);
  const isVitalsAIMode = useVitalsAIMode();

  return (
    <>
      <div className={styles.container}>
        {hideSearch ? (
          <div className={styles.inlineTitleRow}>
            {leftIcon}
            {inlineTitle && (
              <span className={styles.inlineTitle}>{inlineTitle}</span>
            )}
          </div>
        ) : !isVitalsAIMode && !isHomeHealthExternal ? (
          <div
            className={classNames(
              styles.searchBarCon,
              !rightIcon && styles.searchBarConNoRight
            )}
          >
            <div className={styles.searchCon} id="global-search">
              {isLocalSearchPage ? (
                <LocalSearchBar leftIcon={leftIcon} />
              ) : (
                <GlobalSearchBar
                  leftIcon={leftIcon}
                  onSearchClick={onClickSearch}
                />
              )}
            </div>
          </div>
        ) : (
          // Show only the menu icon when in vitals AI mode
          <div className={styles.searchBarCon}>
            <div className={styles.searchCon}>{leftIcon}</div>
          </div>
        )}
        {!hideSearch && rightIcon}
      </div>
      {title && (
        <h5 className={styles.heading} id="main-heading">
          {title}
        </h5>
      )}
    </>
  );
};
